import { useCallback, useState } from "react";

type CopyFn = (text: string) => Promise<boolean>;

export function useCopyToClipboard(delay = 2000): [CopyFn, boolean] {
  const [copied, setCopied] = useState(false);

  const copy: CopyFn = useCallback(
    async (text) => {
      if (!navigator?.clipboard) return false;
      try {
        await navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), delay);
        return true;
      } catch {
        return false;
      }
    },
    [delay],
  );

  return [copy, copied];
}
